import { Heading } from "@bcc-ui/ui-components";
import React from "react";
import { useTranslation } from "react-i18next";

import { VideoIcon } from "components/icons/VideoIcon";
import { LinkTextBox } from "components/link-text-box/LinkTextBox";

interface Props {
    onClick: () => void;
}
export const VideoTutorialButton = (props: Props) => {
    const { t } = useTranslation();

    return (
        <LinkTextBox icon={<VideoIcon color={"var(--theme-icon-fill-default)"} />} onClick={props.onClick}>
            <Heading variant="SUBTITLE_2">{t("Onboarding.home.watchTutorial")}</Heading>
        </LinkTextBox>
    );
};
